import { z } from "zod";
import { LocalDate, SecurityId } from "../Types";
export const RebalancerMetrics = z
    .object({
    as_of_date: LocalDate,
    rebalancer_active_accounts_count: z.number(),
    rebalancer_total_accounts_count: z.number(),
    rebalancer_trades_30_days_count: z.number(),
    rebalancer_trades_12_month_count: z.number(),
    rebalancer_trades_all_time_count: z.number(),
    tax_loss_harvesting_swap_count: z.number(),
})
    .transform((metrics) => ({
    asOfDate: metrics.as_of_date,
    rebalancerActiveAccountsCount: metrics.rebalancer_active_accounts_count,
    rebalancerTotalAccountsCount: metrics.rebalancer_total_accounts_count,
    rebalancerTrades30DaysCount: metrics.rebalancer_trades_30_days_count,
    rebalancerTrades12MonthCount: metrics.rebalancer_trades_12_month_count,
    rebalancerTradesAllTimeCount: metrics.rebalancer_trades_all_time_count,
    taxLossHarvestingSwapCount: metrics.tax_loss_harvesting_swap_count,
}));
export const TasksMetrics = z
    .object({
    as_of_date: LocalDate,
    tasks_30_days_count: z.number(),
    tasks_12_month_count: z.number(),
    tasks_all_time_count: z.number(),
})
    .transform((metrics) => ({
    asOfDate: metrics.as_of_date,
    tasks30DaysCount: metrics.tasks_30_days_count,
    tasks12MonthCount: metrics.tasks_12_month_count,
    tasksAllTimeCount: metrics.tasks_all_time_count,
}));
export const SecuritySchema = z.object({
    id: SecurityId,
    name: z.string().nullable(),
    description: z.string().nullable(),
    type: z.string(),
    state: z.string(),
    identifiers: z.array(z.object({
        securityId: SecurityId,
        identifier: z.string(),
        registrar: z.string(),
        state: z.string(),
        description: z.string().nullable(),
    })),
});
export const FartherHoldingSchema = z.object({
    farther_holding_id: z.string().nullish(),
    farther_physical_account_id: z.string().nullish(),
    farther_virtual_account_id: z.string().nullish(),
    custodian_account_id: z.string().nullish(),
    vendor_account_id: z.string().nullish(),
    bd_batch_row_id: z.string().nullish(),
    farther_security_id: z.string().nullish(),
    as_of_date: z.string().nullish(),
    vendor_holding_id: z.string().nullish(),
    vendor_asset_id: z.number().nullish(),
    ticker: z.string().nullish(),
    cusip: z.string().nullish(),
    display_cusip: z.string().nullish(),
    alternate_id: z.string().nullish(),
    asset_name: z.string().nullish(),
    asset_name_short: z.string().nullish(),
    class_name: z.string().nullish(),
    class_id: z.number().nullish(),
    segment_name: z.string().nullish(),
    segment_id: z.number().nullish(),
    asset_id: z.number().nullish(),
    discretionary: z.boolean().nullish(),
    issue_type: z.string().nullish(),
    provider_issue_type: z.string().nullish(),
    supervised: z.boolean().nullish(),
    quantity: z.number().nullish(),
    billable: z.boolean().nullish(),
    money_market: z.boolean().nullish(),
    market_value: z.number().nullish(),
    investment_discretion: z.string().nullish(),
    voting_authority: z.string().nullish(),
    price_factor: z.number().nullish(),
    paydown_factor: z.number().nullish(),
    coupon_rate: z.number().nullish(),
    muni_state: z.string().nullish(),
    call_date: z.string().nullish(),
    yield: z.number().nullish(),
    sector: z.string().nullish(),
    cash: z.boolean().nullish(),
    asset_tags: z.string().nullish(),
    maturity_date: z.string().nullish(),
    accrual: z.number().nullish(),
    exchange: z.string().nullish(),
    long_holding: z.boolean().nullish(),
    created_time: z.string().nullish(),
    modified_time: z.string().nullish(),
    data_source: z.string().nullish(),
    latest_time: z.string().nullish(),
    taxLots: z.array(z.any()).nullish(),
    costBasis: z.number().nullish(),
    cost_basis: z.number().nullish(),
    costBasisDate: z.string().nullish(),
    realized_long_term_gain_loss: z.number().nullish(),
    realized_short_term_gain_loss: z.number().nullish(),
    unrealized_long_term_gain_loss: z.number().nullish(),
    unrealized_short_term_gain_loss: z.number().nullish(),
    date: z.string().nullish(),
    accountId: z.string().nullish(),
    marketValue: z.number().nullish(),
    modifiedTs: z.string().nullish(),
    createdTs: z.string().nullish(),
});
// Extended schema for holdings with security details
export const ExtendedFartherHoldingSchema = FartherHoldingSchema.extend({
    securityDetails: SecuritySchema.optional(),
});
// Extended array schema to validate the array of holdings with expanded security details
export const ExtendedFartherHoldingsArraySchema = z.object({
    records: z.array(ExtendedFartherHoldingSchema),
});
//# sourceMappingURL=Types.js.map